

import { CustomerCompany, DerivativeOption, MarkUpMetrixListResponse, MarkUpMetrixPayload, MarkUpMetrixRecord, UOMOption } from "../../Types/Customermarkupmetrix.types";
import axiosInstance from "../../Utils/axiosInstance";

export const fetchCustomerCompanies = async (): Promise<CustomerCompany[]> => {
  const { data } = await axiosInstance.get("/paper-app/customer-company-dropdown/");
  return data;
};

export const fetchDerivatives = async (): Promise<DerivativeOption[]> => {
  const { data } = await axiosInstance.get("/paper-app/derivative-dropdown/");
  return data;
};

export const fetchUOMs = async (): Promise<UOMOption[]> => {
  const { data } = await axiosInstance.get("/paper-app/unit-dropdown/");
  return data;
};

// ─── MarkUp Matrix CRUD ───────────────────────────────────────────────────────

export const fetchMarkUpMatrixList = async (page: number, pageSize: number) => {
  const response = await axiosInstance.get(
    `/paper-app/customer-markup-matrix/?page=${page}&page_size=${pageSize}`
  );
  return response.data;
};

export const fetchMarkUpMatrixDetail = async (
  id: string
): Promise<MarkUpMetrixRecord> => {
  const { data } = await axiosInstance.get(
    `/paper-app/customer-markup-matrix/${id}/`
  );
  return data;
};

export const createMarkUpMetrix = async (
  payload: MarkUpMetrixPayload
): Promise<MarkUpMetrixRecord> => {
  const { data } = await axiosInstance.post(
    "/paper-app/customer-markup-matrix/",
    payload
  );
  return data;
};

export const updateMarkUpMetrix = async (
  id: string,
  payload: MarkUpMetrixPayload
): Promise<MarkUpMetrixRecord> => {
  const { data } = await axiosInstance.put(
    `/paper-app/customer-markup-matrix/${id}/`,
    payload
  );
  return data;
};

export const deleteMarkUpMetrix = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/paper-app/customer-markup-matrix/${id}/`);
};

// ─── Data Export 

export const exportCustomerMarkupMatrix = async (): Promise<Blob> => {
  const response = await axiosInstance.get(
    "/paper-app/customer-markup-matrix/export",
    {
      responseType: "blob",
    }
  );

  return response.data;
};